import DOMPurify from 'dompurify';
import i18n from 'shared/i18n';

import HandshqApp from '../handshq-app/handshq-app';

$(setUpTooltips);

export function setUpTooltips() {
  setupPopoverTooltips();
  setupAutoHoverPopover();
}

function setupAutoHoverPopover() {
  addPopover($('.hover-popover'));
}

function setupPopoverTooltips() {
  showTooltipsOnClick();
  hideTooltipsOnClickAway();
}

function showTooltipsOnClick() {
  $('.tooltip-popover').each(function () {
    const _this = this;
    const text = $(this).data('text');
    const withoutTitle = $(this).data('without-title');

    const title =
      $(this).data('text-title') || i18n.t('shared.tooltip.tip', { ns: 'js' });

    const tooltipDark = $(this).data('tooltip-dark');
    const trigger = $(this).data('trigger');
    const widePopover = $(this).data('wide-popover');
    const style = $(this).data('style');
    const size = $(this).data('size');
    const wrap = $(this).data('wrap');
    const hidePopover = function (_e) {
      $(_this).popover('hide');
    };

    $(this).popover({
      title: withoutTitle ? null : title,
      content: text,
      trigger: trigger || 'click',
      // Bootstrap's built-in sanitizer rebuilds a throwaway HTMLDocument on every call, which is
      // expensive at scale. DOMPurify sanitizes just as strictly without that cost.
      sanitizeFn: DOMPurify.sanitize,
    });

    if (!withoutTitle) {
      $(this)
        .data('bs.popover')
        .tip()
        .find('.popover-title')
        .addClass('popover-title--text-left');
      $(this)
        .data('bs.popover')
        .tip()
        .find('.popover-content')
        .addClass('popover-content--text-left');
    }

    if (style) {
      $(this)
        .data('bs.popover')
        .tip()
        .find('.popover-content')
        .addClass(`popover-content--${style}`);
      $(this)
        .data('bs.popover')
        .tip()
        .find('.arrow')
        .addClass(`arrow--${style}`);
    }

    if (size) {
      $(this).data('bs.popover').tip().addClass(`popover--${size}`);
    }

    if (wrap) {
      $(this).data('bs.popover').tip().addClass('popover--pre-wrap');
    }

    if (tooltipDark) {
      $(this).data('bs.popover').tip().addClass('popover--dark');
      $(this).data('bs.popover').tip().find('.arrow').addClass('arrow--dark');
    }

    // Nadmin scss class
    if (widePopover) {
      $(this).data('bs.popover').tip().addClass('popover--wide');
    }

    $(this).on('shown.bs.popover', () => {
      $('.custom-tooltip__popover').find('.close').on('click', hidePopover);
    });

    $(this).on('hide.bs.popover', () => {
      $('.custom-tooltip__popover').find('.close').off('click', hidePopover);
    });
  });
}

function hideTooltipsOnClickAway() {
  $('.tooltip-popover').on('click', function (_e) {
    $('.tooltip-popover').not(this).popover('hide');
  });
}

function addPopover(element) {
  const trigger = HandshqApp.mobileDetect.mobile() ? 'click' : 'hover';
  $(element).each((_, rawElement) => {
    const $element = $(rawElement);

    // Avoid re-initializing existing popovers when addPopover is called repeatedly.
    // sanitizeFn: see comment in showTooltipsOnClick above.
    if (!$element.data('bs.popover'))
      $element.popover({ trigger, sanitizeFn: DOMPurify.sanitize });

    // Remove any previous event handlers to prevent multiple event listeners for the same event.
    $element.off('shown.bs.popover.customPopoverClass');

    // Add custom class only when the popover is shown so we do not eagerly build tips.
    const needsCustomPopoverClass =
      !$element.closest('.tooltip-container').length;
    if (needsCustomPopoverClass) {
      $element.on('shown.bs.popover.customPopoverClass', () => {
        // Add a custom class to the popover tip once it is shown.
        const popover = $element.data('bs.popover');
        if (popover) popover.tip().addClass('custom-popover');
      });
    }
  });
}

window.setupAutoHoverPopover = setupAutoHoverPopover;
window.addPopover = addPopover;
